import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface IAccordionCombination {
  accordions: {
    title: string | JSX.Element;
    children: JSX.Element;
    resetForm?: boolean
  }[]
}

const AccordionCombination = (props: IAccordionCombination) => {
  const { accordions } = props;
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded
        ? panel
        : false);
    };

  return (
    <>
      {
        accordions.map((
          accordion: { title: string | JSX.Element, children: JSX.Element },
          index: number
        ) => {
          return (
            <Accordion
              key={String(accordion.title)} 
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}bh-content`}
                id={`panel${index}bh-header`}
              >
                <Typography variant='h4' sx={{ width: '33%', flexShrink: 0 }}>
                  {accordion.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {accordion.children}
              </AccordionDetails>
            </Accordion>
          );
        })
      }
    </>
  );
};

export default AccordionCombination;